"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericCollectionDriver = void 0;
var tslib_1 = require("tslib");
var postcss = tslib_1.__importStar(require("postcss"));
var stylable_collection_1 = require("./stylable-collection");
var stylable_shorthands_1 = require("../stylable-shorthands");
var GenericCollectionDriver = /** @class */ (function (_super) {
    tslib_1.__extends(GenericCollectionDriver, _super);
    function GenericCollectionDriver(getStylesheet, resolveSymbol, updateFromAST, basePropName, propNames) {
        var _this = _super.call(this, getStylesheet, resolveSymbol, updateFromAST) || this;
        _this.basePropName = basePropName;
        _this.propNames = propNames;
        return _this;
    }
    GenericCollectionDriver.prototype.router = function (decl, sheet, declarations) {
        var e_1, _a;
        var addProp = stylable_collection_1.addChangeContext.bind(this, declarations, decl);
        var shorthands = new stylable_shorthands_1.StylableShorthands(sheet.evalDeclarationValue.bind(sheet));
        if (this.basePropName === decl.prop || (this.propNames && ~this.propNames.indexOf(decl.prop))) {
            this.handleGenericProp(sheet, decl.value, addProp);
        }
        else {
            var shorthandProps = shorthands.getShorthandProps(this.basePropName);
            if (~shorthandProps.indexOf(decl.prop)) {
                this.handleShorthandProp(sheet, decl, addProp);
                return;
            }
            if (this.propNames) {
                try {
                    for (var _b = tslib_1.__values(this.propNames), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var propName = _c.value;
                        var shorthand = shorthands.getShorthandProps(propName);
                        if (~shorthand.indexOf(decl.prop)) {
                            this.handleShorthandProp(sheet, decl, addProp);
                            return;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
    };
    GenericCollectionDriver.prototype.handleGenericProp = function (sheet, declValue, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        function changeDirectProp(value) {
            this.declaration.value = value;
            updateFromAST(this.declaration);
        }
        adder(sheet.evalDeclarationValue(declValue), changeDirectProp);
    };
    GenericCollectionDriver.prototype.handleShorthandProp = function (sheet, decl, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        var shorthands = new stylable_shorthands_1.StylableShorthands(sheet.evalDeclarationValue.bind(sheet));
        var basePropName = this.basePropName;
        function changeShorthandProp(value) {
            var changeExpanded = shorthands.expandDeclaration(postcss.decl({ prop: basePropName, value: value }));
            var changeValue = changeExpanded[decl.prop];
            if (changeValue) {
                this.declaration.value = changeValue;
                updateFromAST(this.declaration);
            }
        }
        adder(sheet.evalDeclarationValue(decl.value), changeShorthandProp);
    };
    return GenericCollectionDriver;
}(stylable_collection_1.CollectionDriver));
exports.GenericCollectionDriver = GenericCollectionDriver;
//# sourceMappingURL=generic-collection.js.map